export const millenium = 1000 * 365 * 24 * 60 * 60 * 1000;
